import { universityRestriction } from '../../utility/universityRestrictions';
import { sectionKeys } from '../helpers/titleToSectionKeyDict';
import { UNIVERSITYPLAN } from '../../utility/enums/planType';
import { generateSectionObjectArray } from './getDefaultResumeUserPreferences';

export const getDefaultSections = (selectedPlan, universityPlan) => {
  let used = [];
  let unUsed = [];
  const wisedocDefaultUsedSections = [
    'personalInfo',
    'summary',
    'education',
    'skills',
    'projects',
    'workExperience',
  ];
  if (selectedPlan && selectedPlan === UNIVERSITYPLAN && universityPlan?.code) {
    const defaultSections =
      universityRestriction[universityPlan?.code]?.editor?.resume?.sections
        ?.defaultSections || wisedocDefaultUsedSections;
    used = generateSectionObjectArray({
      sectionsArray: defaultSections,
      toExport: true,
      warning: false,
      selectedPlan,
      universityPlan,
    });
    const unUsedSections = sectionKeys?.filter(
      (section) => !defaultSections?.includes(section),
    );
    unUsed = generateSectionObjectArray({
      sectionsArray: unUsedSections,
      toExport: false,
      warning: false,
      selectedPlan,
      universityPlan,
    });
  } else {
    used = generateSectionObjectArray({
      sectionsArray: wisedocDefaultUsedSections,
      toExport: true,
      warning: false,
      selectedPlan,
      universityPlan,
    });
    const unUsedSections = sectionKeys?.filter((section) => {
      return !wisedocDefaultUsedSections?.includes(section);
    });

    unUsed = generateSectionObjectArray({
      sectionsArray: unUsedSections,
      toExport: false,
      warning: false,
      selectedPlan,
      universityPlan,
    });
  }
  return {
    used,
    unUsed,
  };
};
